<div class="gewerk-grid">
  @for (gewerk of gewerke(); track gewerk.id) {
    <button
      class="gewerk-card"
      (click)="kategorieSelected.emit(gewerk)"
      [attr.aria-label]="gewerk.label + ' auswählen'"
      type="button"
    >
      <div class="gewerk-card__icon">
        <app-gewerk-icon [gewerkId]="gewerk.id" [size]="18" />
      </div>
      <div class="gewerk-card__body">
        <span class="gewerk-card__label">{{ gewerk.label }}</span>
      </div>
    </button>
  }

  <!-- 12. Kachel: schließt das 4×3-Raster, keine Waise -->
  <button
    class="gewerk-card gewerk-card--all"
    (click)="alleSelected.emit()"
    aria-label="Alle Gewerke ansehen"
    type="button"
  >
    <div class="gewerk-card__body">
      <span class="gewerk-card__label">
        Alle Gewerke
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
      </span>
    </div>
  </button>
</div>
